import React, { useState, useEffect } from 'react';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import { IconButton } from '@mui/material';

import '../style/reload-button.css';

export const ReloadButton = ({
  onClick,
  disabled = false,
  isLoading = null,
}) => {
  const [internalRotate, setInternalRotate] = useState(false);

  useEffect(() => {
    if (internalRotate) {
      const timer = setTimeout(() => {
        setInternalRotate(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [internalRotate]);

  const handleClick = () => {
    if (isLoading === null && !internalRotate) {
      setInternalRotate(true);
    }
    onClick();
  };

  const rotate = isLoading !== null ? isLoading : internalRotate;

  return (
    <IconButton disabled={disabled || rotate} onClick={handleClick}>
      <AutorenewIcon className={rotate ? 'rotate' : ''} />
    </IconButton>
  );
};
